module.exports = __webpack_public_path__ + "static/img/manual-18.08ae572.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/vi/mobile/manual-18.png
// module id = YMDp
// module chunks = 4